export const SET_PORTFOLIO = 'SET_PORTFOLIO';
export const TOOGLE_SIDEBAR = 'TOOGLE_SIDEBAR';